import { render } from "./HeroHeader.vue?vue&type=template&id=47c8f538&scoped=true"
import script from "./HeroHeader.vue?vue&type=script&lang=js"
export * from "./HeroHeader.vue?vue&type=script&lang=js"

import "./HeroHeader.vue?vue&type=style&index=0&id=47c8f538&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c8f538"]])

export default __exports__